import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from './PhoneSupport';
import { useAppSelector } from '../../reducers';
import { isUngatedForInbound25Selector } from '../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PhoneSupportMiddle = props => {
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  if (isUngatedForInbound) return null;
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx(PhoneSupport, Object.assign({}, props))
  });
};
export default PhoneSupportMiddle;